import { jsx as _jsx } from "react/jsx-runtime";
import * as React from "react";
import { Badge } from "../../base/badge/badge";
/**
 * THE kind→color mapping for OrgFunctions. Canonicalized on the EntityCard
 * palette that already shipped (team = violet, role = amber); every surface
 * that colors a kind badge or kind icon must consume these tokens instead of
 * declaring its own scheme.
 */ export const ORG_FUNCTION_KIND_TONES = {
    team: "violet",
    role: "amber"
};
/**
 * The canonical kind pill for an OrgFunction (team/role). Consumers pass the
 * translated label; the badge owns shape and the shared kind tone.
 */ export function OrgFunctionKindBadge({ kind, label, className }) {
    return /*#__PURE__*/ _jsx(Badge, {
        variant: "outline",
        shape: "pill",
        colorScheme: ORG_FUNCTION_KIND_TONES[kind],
        className: className,
        children: label
    });
}

//# sourceMappingURL=OrgFunctionKindBadge.js.map